<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <Slider
      style="width: 98%;"
      :value="value"
      :min="0"
      :max="12"
      :step="1"
      :tip-format="val => `${val} / 12`"
      @on-change="onInputChange"
    ></Slider>
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'

export default {
  name: 'zpaSlider',

  mixins: [
    inputMixin,
  ],

  props: {
    value: [Number, Array],
  },
}
</script>
